var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":_vm.variant,"disabled":_vm.disabled,"title":_vm.title},on:{"click":_vm.doAction}},[(_vm.loading)?_c('b-spinner',{attrs:{"label":"Spinning"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }